import { render, staticRenderFns } from "./DialogCheckoutSetting.pug?vue&type=template&id=01cc1ba6&scoped=true&lang=pug&"
import script from "./DialogCheckoutSetting.vue?vue&type=script&lang=js&"
export * from "./DialogCheckoutSetting.vue?vue&type=script&lang=js&"
import style0 from "./DialogCheckoutSetting.scss?vue&type=style&index=0&id=01cc1ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cc1ba6",
  null
  
)

export default component.exports